import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaGlacierApi = createApi({
    reducerPath: "core/measurement/glacier",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementGlacierList"],
    endpoints: (builder) =>({
        measurementGlacierFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementGlacierList'],
            query: (query = '') => ({
                url: "core/measurement/glacier" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementGlacierCreate: builder.mutation({
            invalidatesTags: ['measurementGlacierList'],
            query: (data)=>({url: "core/measurement/glacier", method: "POST", data})
        }),
        measurementGlacierUpdate: builder.mutation({
            invalidatesTags: ['measurementGlacierList'],
            query: (data)=>({url: "/core/measurement/glacier/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        measurementGlacierDelete: builder.mutation({
            invalidatesTags: ['measurementGlacierList'],
            query: (id)=>({url: "/core/measurement/glacier/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementGlacierFindAllQuery, useMeasurementGlacierCreateMutation, useMeasurementGlacierUpdateMutation, useMeasurementGlacierDeleteMutation } = meaGlacierApi;
export {meaGlacierApi};
